import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { AbstractControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-org-number',
    templateUrl: './organization-number.component.html',
    styleUrls: ['./organization-number.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrganizationNumberComponent implements OnInit {
  constructor() {}

  private _control: FormControlEx;
  // Accept the base AbstractControl so templates can bind `form.controls['x']`
  // (typed AbstractControl) under strictTemplates; stored/exposed as FormControlEx.
  @Input() set control(value: AbstractControl) {
    this._control = value as FormControlEx;
  }
  get control(): FormControlEx {
    return this._control;
  }

  readonly format: string = 'NNNNNN-NNNN';
  readonly mask: RegExp = /^(\d{6}\-\d{0,4})|(\d{1,6})/;

  ngOnInit() {
    this.control.required = true;
  }
}
